import axios from "axios";
import { useMutation, useQuery } from "react-query";
import { API_URL, securityHeaders } from "../Constants";
import { isEmpty } from "lodash";

const fetchNews = async ({
  pageSize,
  pageNumber,
  year,
  selectedActivity,
  searchKey,
}) => {
  return await axios.get(
    API_URL +
      `/api/News/GetNews/${pageSize}/${pageNumber}${
        !isEmpty(searchKey) ? "?SearchBy=" + searchKey : ""
      }${
        null !== selectedActivity && !isEmpty(searchKey)
          ? "&IsActive=" + selectedActivity
          : null !== selectedActivity && isEmpty(searchKey)
          ? "?IsActive=" + selectedActivity
          : ""
      }`,
    {
      headers: securityHeaders,
    }
  );
};

const fetchNewsById = async ({ id }) => {
  return await axios.get(API_URL + `/api/News/GetNewsById/${id}`, {
    headers: securityHeaders,
  });
};

const fetchNewsCategories = async () => {
  return await axios.get(API_URL + `/api/News/GetCategories`, {
    headers: securityHeaders,
  });
};

const fetchEvents = async ({
  pageSize,
  pageNumber,
  year,
  selectedActivity,
  searchKey,
}) => {
  return await axios.get(
    API_URL +
      `/api/News/GetEvents/${pageSize}/${pageNumber}${
        !isEmpty(searchKey) ? "?SearchBy=" + searchKey : ""
      }${
        null !== selectedActivity && !isEmpty(searchKey)
          ? "&IsActive=" + selectedActivity
          : null !== selectedActivity && isEmpty(searchKey)
          ? "?IsActive=" + selectedActivity
          : ""
      }`,
    {
      headers: securityHeaders,
    }
  );
};

const deleteNews = (newsId) => {
  return axios.post(
    API_URL + `/api/News/DeleteNews/${newsId}`,
    {},
    {
      headers: securityHeaders,
    }
  );
};

export const useFetchNews = ({
  pageSize,
  pageNumber,
  year,
  selectedActivity,
  searchKey,
}) => {
  return useQuery({
    queryKey: ["news"],
    queryFn: () =>
      fetchNews({ pageSize, pageNumber, year, selectedActivity, searchKey }),
    enabled: true,
    refetchOnWindowFocus: false,
  });
};

export const useFetchNewsById = ({ id }) => {
  return useQuery({
    queryKey: [`newsById-${id}`],
    queryFn: () => fetchNewsById({ id }),
    enabled: false,
    refetchOnWindowFocus: false,
  });
};

export const useFetchNewsCategories = () => {
  return useQuery({
    queryKey: ["newsCategories"],
    queryFn: () => fetchNewsCategories(),
    enabled: true,
    refetchOnWindowFocus: false,
  });
};

export const useFetchEvents = ({
  pageSize,
  pageNumber,
  year,
  selectedActivity,
  searchKey,
}) => {
  return useQuery({
    queryKey: ["events"],
    queryFn: () =>
      fetchEvents({ pageSize, pageNumber, year, selectedActivity, searchKey }),
    enabled: true,
    refetchOnWindowFocus: false,
  });
};

export const useDeleteNews = (newsId) => {
  return useMutation(() => deleteNews(newsId));
};
